import { FormattedMessage } from 'react-intl';
import helperStyle from '~/components/styles/helpers.module.scss';
import { useQuerySet } from '~/contexts/QuerysetContext';
import { useConfig } from '~/core/configuration/configContext';
import { useShownAttributes } from '~/hooks/useShownAttributes';
import formatCurrency from '~/utils/components/formatCurrency';
import { useProductContext } from './productResultContext';

const ProductResultPrice = () => {
    const { result, style } = useProductContext();
    const config = useConfig();
    const { state: querySetState } = useQuerySet();
    const { shouldRenderKey } = useShownAttributes({ querySetState });

    const currency = config.layout.configuration.currency ?? 'CZK';
    const showPriceWithVatSuffix = config.layout.configuration.showPriceWithVatSuffix;
    const locale = config.layout.configuration.locale;

    return (
        <div role="paragraph" className={style.serpProductPrice}>
            {result.originalPrice &&
            result.price !== undefined &&
            result.originalPrice > result.price &&
            shouldRenderKey('originalPrice') ? (
                <>
                    <span
                        className={helperStyle.visuallyHidden}
                        key="original_price"
                        data-testid="product-result-original-price"
                    >
                        <FormattedMessage id="original_price" defaultMessage="Stará cena" />
                    </span>
                    <s className={style.strikeout}>{formatCurrency(result.originalPrice, currency, locale)}</s>
                </>
            ) : null}
            {result.price !== undefined &&
                (result.price === 0 || result.price === null ? (
                    <>
                        <span
                            className={helperStyle.serpProductPriceNoVat}
                            key="price_on_request"
                            data-testid="product-result-request-price"
                        >
                            <FormattedMessage id="price_on_request" defaultMessage="Na dotaz" />
                        </span>
                    </>
                ) : (
                    <>
                        <span className={helperStyle.visuallyHidden} key="price" data-testid="product-result-price">
                            <FormattedMessage id="new_price" defaultMessage="Nová cena" />
                        </span>
                        <span className={style.serpProductPriceFromAndVat}>
                            <strong>
                                {result.lowestPrice ? (
                                    <>
                                        <FormattedMessage id="price_from" defaultMessage="od" />{' '}
                                    </>
                                ) : null}
                            </strong>
                            <strong>
                                {formatCurrency(result.price, currency, locale)}
                                {result.unit ? `/${result.unit}` : ''}
                            </strong>

                            {showPriceWithVatSuffix && (
                                <span className={style.serpProductPriceVat} data-testid="product-result-price-with-vat">
                                    <FormattedMessage id="with_vat_suffix" defaultMessage="s DPH" />
                                </span>
                            )}
                        </span>
                    </>
                ))}
            {result.priceWithoutVat !== undefined && result.price !== 0 && shouldRenderKey('priceWithoutVat') && (
                <span
                    className={style.serpProductPriceNoVat}
                    key="price_no_vat"
                    data-testid="product-result-price-without-vat"
                >
                    <span className={helperStyle.visuallyHidden}>
                        <FormattedMessage id="price_no_vat" defaultMessage="Cena bez DPH" />
                    </span>
                    <span>
                        {formatCurrency(result.priceWithoutVat, currency, locale)}{' '}
                        <span>
                            <FormattedMessage id="no_vat" defaultMessage="bez DPH" />
                        </span>
                    </span>
                </span>
            )}
        </div>
    );
};

export default ProductResultPrice;
